package com.milta.feature.admin.presentation

import com.milta.feature.admin.domain.entity.AdminClaudeUsage
import com.milta.feature.admin.domain.entity.AdminClaudeUsageEvents
import com.milta.feature.admin.domain.entity.AdminClaudeUsagePeriod

enum class AdminClaudeUsageViewMode { ByAccount, ByOrganisation }

/** State for the Admin "Conso. IA" screen. [eventsByAccount] caches the per-call drill-down
 * already fetched for an expanded row — re-expanding a previously-opened account never re-fetches
 * within the same [period]. */
data class AdminClaudeUsageState(
    val isLoading: Boolean = true,
    val period: AdminClaudeUsagePeriod = AdminClaudeUsagePeriod.Last7Days,
    val view: AdminClaudeUsageViewMode = AdminClaudeUsageViewMode.ByAccount,
    val usage: AdminClaudeUsage? = null,
    /** "server_error" | "offline". */
    val error: String? = null,
    val expandedAccountId: String? = null,
    val eventsByAccount: Map<String, AdminClaudeUsageEvents> = emptyMap(),
    val eventsLoadingAccountId: String? = null,
)
